import React from 'react';

const AccordionChild = ({
  accordionConfig,
  accordionHead,
  bodyComponent,
  index,
  isActive,
  updateActiveIndex,
  innerRef = null,
  item,
  gameday_id
}) => {
  const { showAccordArrow = true } = accordionConfig;

  const handleOpen = () => {
    updateActiveIndex(index, gameday_id);
  };

  return (
    <>
      <div className='si-accordion__box' ref={innerRef}>
        <button
          type='button'
          aria-expanded={isActive}
          className='si-accordion__trigger'
          aria-controls={`section${index}`}
          id={`accordion${index}`}
          onClick={handleOpen}
        >
          {accordionHead}
          {showAccordArrow && (
            <div className='si-accordion__icon'>
              <i className='lms-chevron-down'></i>
            </div>
          )}
        </button>
        <div
          id={`section${index}`}
          role='region'
          aria-labelledby={`accordion${index}`}
          className='si-accordion__body'
          hidden={!isActive}
        >
          {bodyComponent}
        </div>
      </div>
    </>
  );
};

export default AccordionChild;
